import http from '../http'

export default {
  getRequests () {
    return http.get('/billing')
  },
  retryTransaction (billingRequest) {
    return http.post('/billing/retry', billingRequest)
  }
}
